module.exports = __webpack_public_path__ + "static/img/Railway-Hotel-Yarraville.dae63b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Railway-Hotel-Yarraville.jpg
// module id = u/zF
// module chunks = 0